import { axiosInstance } from 'src/util/axios/instance.axios'
import { ProfessionFieldsType, SkillCategory, SkillLevelUpdatePayload } from '../model/skill-assessment-model'

export async function getSkillSets(userId?: string): Promise<SkillCategory[]> {
  const url = userId ? `/skill-assessment/skill-sets/${userId}` : '/skill-assessment/skill-sets'
  const { data } = await axiosInstance.request<SkillCategory[]>({
    url,
  })

  return data
}

export async function addSkillAssessment(set_id: string, selected_set_level: number): Promise<any> {
  const { data } = await axiosInstance.request({
    url: '/skill-assessment/skill-rating',
    method: 'post',
    data: {
      set_id,
      selected_set_level,
    },
  })

  return data
}

export async function getProfessionFields(): Promise<ProfessionFieldsType[]> {
  const { data } = await axiosInstance.request({
    url: '/skill-assessment/skill-data',
  })

  return data
}

export async function getSkillCategory(levelId: string): Promise<SkillCategory> {
  const { data } = await axiosInstance.request<SkillCategory>({
    url: `/skill-assessment/skill-category/${levelId}`,
  })

  return data
}

export async function addSkillCategory(professionField: string, roleName: string, levelId: string): Promise<any> {
  const { data } = await axiosInstance.request({
    url: `/skill-assessment/skill-category/`,
    method: 'post',
    data: {
      professionField,
      roleName,
      levelId,
    },
  })

  return data
}

export async function addExpectedLevel(set_id: string, set_name: string, expected_set_level: number): Promise<any> {
  const { data } = await axiosInstance.request({
    url: '/skill-assessment/expected-level',
    method: 'post',
    data: {
      set_id,
      set_name,
      expected_set_level,
    },
  })

  return data
}

export async function deleteExpectedRole(levelId: string): Promise<void> {
  await axiosInstance.request({
    url: `/skill-assessment/expected-role/${levelId}`,
    method: 'delete',
  })
}

export async function deleteSkillSet(setId: string, categoryId: string): Promise<void> {
  await axiosInstance.request({
    url: `/skill-assessment/skill-set/${setId}/${categoryId}`,
    method: 'delete',
  })
}

export async function addSkillSet(professionField: string, skillSetTitle: string, categoryId: string): Promise<void> {
  await axiosInstance.request({
    url: '/skill-assessment/skill-set',
    method: 'post',
    data: {
      professionField,
      skillSetTitle,
      categoryId,
    },
  })
}

export async function validateUserSkillAssessment(userId: string, setId: string, isValidated: boolean): Promise<any> {
  const { data } = await axiosInstance.request({
    url: '/skill-assessment/skill-validation',
    method: 'post',
    data: {
      userId,
      setId,
      isValidated,
    },
  })

  return data
}

export async function deleteOrganizationSkill(skillName: string): Promise<void> {
  await axiosInstance.request({
    url: '/skill-assessment/organization-skill',
    method: 'post',
    data: {
      skillName,
    },
  })
}

export async function updateSkillWithLevels(data: SkillLevelUpdatePayload): Promise<void> {
  await axiosInstance.request({
    url: '/skill-assessment/skill-level-update',
    method: 'put',
    data,
  })
}

export async function resetUserSkill(userId: string, setId: string): Promise<void> {
  await axiosInstance.request({
    url: `/skill-assessment/skill-reset/${userId}/${setId}`,
    method: 'delete',
  })
}

export async function resetAllUserSkills(userId: string, categoryId: string): Promise<void> {
  await axiosInstance.request({
    url: `/skill-assessment/skill-reset-all/${userId}/${categoryId}`,
    method: 'delete',
  })
}

export async function validateAllUserSkills(userId: string, categoryId: string, isValidated: boolean): Promise<void> {
  await axiosInstance.request({
    url: '/skill-assessment/skill-validation-all',
    method: 'post',
    data: {
      userId,
      categoryId,
      isValidated,
    },
  })
}